import CheckboxItem from './Checkbox';
import { CheckboxGroupProps } from './CheckboxGroup.types';

function CheckboxGroup({
  title,
  options,
  selectedValues,
  disableCheckbox,
  requireAtLeastOne = false,
  onChange,
  disableAllCheckboxes,
}: CheckboxGroupProps) {
  const isOnlyOneSelected = selectedValues.length === 1;

  return (
    <div className="flex flex-col gap-2">
      {title && (
        <div className="text-gray-900v2 text-left font-inter font-medium text-sm leading-5">
          {title}
        </div>
      )}
      <div className="flex flex-col gap-2">
        {options.map((option) => {
          const isChecked = selectedValues.includes(option.value);
          const shouldDisable = disableCheckbox
            ? option.value !== 'none'
            : requireAtLeastOne && isOnlyOneSelected && isChecked;

          return (
            <CheckboxItem
              key={option.value}
              label={option.label}
              value={option.value}
              checked={isChecked}
              onChange={onChange}
              disabled={shouldDisable || disableAllCheckboxes}
              hint={option.hint}
            />
          );
        })}
      </div>
    </div>
  );
}

export default CheckboxGroup;
